import { useQuery } from '@tanstack/react-query';

import { axiosPrivate } from 'app/utils';

export interface WebsiteThemeColorPalette {
  primary: string;
  tint?: string;
  contrast?: string;
}

export interface WebsiteThemeFavicon {
  url: string;
  variant: string;
}

export interface WebsiteTheme {
  logoUrl: string;
  colorPalette: WebsiteThemeColorPalette;
  favicons: WebsiteThemeFavicon[];
}

async function fetchWebsiteTheme(websiteId: string) {
  const { data } = await axiosPrivate.get<WebsiteTheme>(
    `/v3/pharmacist/plus-websites/${websiteId}/versions/preview/themes`
  );
  return data;
}

export interface UseGetWebsiteThemeResult {
  theme: WebsiteTheme | undefined;
  isLoading: boolean;
  isError: boolean;
  error: unknown;
  refetch: () => void;
}

export function useGetWebsiteTheme({ websiteId }: { websiteId: string }): UseGetWebsiteThemeResult {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ['plus-website-theme', websiteId],
    queryFn: () => fetchWebsiteTheme(websiteId),
    enabled: !!websiteId,
    meta: { errorMessage: 'Failed to load theme' },
  });

  return {
    theme: data,
    isLoading,
    isError,
    error,
    refetch,
  };
}
